export default __webpack_public_path__ + "static/media/Login.d02d3343.png";